import type { SourceAssetView, SourceView } from "./api-client.ts";

export interface ShareStudioPrefill {
  key: string;
  selfieId: null;
  sources: Array<{ source: SourceAssetView; originalName: string }>;
}

export function studioPrefillFromShareSource(
  source: SourceView,
  key: string = crypto.randomUUID(),
): ShareStudioPrefill {
  return {
    key,
    selfieId: null,
    sources: [{ source, originalName: source.sourceOriginalName }],
  };
}
